import { Pipe, PipeTransform } from '@angular/core';
import { ThemeColorService } from './theme-color.service';

@Pipe({
  name: 'themeColor',
  standalone: true,
})
export class ThemeColorPipe implements PipeTransform {
  constructor(protected themeColorService: ThemeColorService) {}

  transform(value: any): any {
    let className = '';

    switch (value) {
      case 'text':
        className = this.themeColorService.getTextColor();
        break;

      case 'btn':
        className = this.themeColorService.getBtnColor();
        break;

      case 'btn-light':
        className = this.themeColorService.getBtnLightColor();
        break;

      case 'btn-info':
        className = this.themeColorService.getBtnInfoColor();
        break;

      case 'btn-light-info':
        className = this.themeColorService.getBtnLightInfoColor();
        break;

      case 'btn-gradient':
        className = this.themeColorService.getBtnGradientColor();
        break;

      case 'cancel-btn':
        className = this.themeColorService.getCancelBtnColor();
        break;

      case 'ring-btn-gradient':
        className = this.themeColorService.getRingBtnGradientColor();
        break;

      case 'bg-image':
        // if (this.backgroundImagePath) {
        //   this.element.nativeElement.style.backgroundImage =
        //     'url(' + this.backgroundImagePath + ')';
        //   return '';
        // }

        className = this.themeColorService.getBgImage();
        break;

      // case 'stats-widget-bg-color':
      //   className = this.themeColorService.getStatsWidgetBgColor(
      //     this.statsWidgetNumber
      //   );
      //   break;

      case 'loading-bar':
        className = this.themeColorService.getLoadingBarColor();
        break;

      case 'timer-loading':
        className = this.themeColorService.getTimerLoadingColor();
        break;
    }

    return className;
  }
}
